import PhoneIcon from '@mui/icons-material/Phone';
import { Box, Divider, IconButton, Tooltip } from '@mui/material';
import React from 'react';

import { SidebarPhonePanelProps } from './SidebarPhonePanel.props';
import { AgentStatusDot } from '../../atoms/AgentStatusDot';
import { useConnectOptional } from '../../organisms/ConnectProvider';
import { AgentStatusPill } from '../AgentStatusPill';

// Lives in the left navigation Drawer between the scrollable nav content
// and the user/logout footer. Renders nothing for users without softphone
// permission (ConnectProvider returns no context in that case).

export const SidebarPhonePanel: React.FC<SidebarPhonePanelProps> = ({ isCollapsed }) => {
  const ctx = useConnectOptional();
  if (!ctx) return null;

  const { agent, contact, isPanelOpen, setPanelOpen } = ctx;
  const open = () => setPanelOpen(true);
  const isCalling = contact !== null && contact.state !== 'ended';
  const dotKind = isCalling ? 'onCall' : (agent?.status.kind ?? 'default');

  if (isCollapsed) {
    const label = isCalling
      ? `On call — ${contact?.phoneNumber ?? 'unknown'}`
      : `Phone — ${agent?.status.name ?? 'offline'}`;
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 1 }}>
        <Tooltip title={label} placement="right">
          <IconButton
            onClick={open}
            aria-label={label}
            aria-pressed={isPanelOpen}
            size="small"
            sx={{
              color: '#cbd5e1',
              position: 'relative',
              '&:hover': { color: '#fff', bgcolor: 'rgba(148,163,184,0.12)' },
            }}
          >
            <PhoneIcon sx={{ fontSize: 20 }} />
            <Box sx={{ position: 'absolute', bottom: 4, right: 4 }}>
              <AgentStatusDot kind={dotKind} pulse={isCalling} size={7} />
            </Box>
          </IconButton>
        </Tooltip>
      </Box>
    );
  }

  return (
    <Box sx={{ width: '100%' }}>
      <Divider sx={{ borderColor: '#334155' }} />
      <Box sx={{ px: 1, py: 1 }}>
        <AgentStatusPill agent={agent} contact={contact} onClick={open} />
      </Box>
    </Box>
  );
};
